import 'angular';

import { BookingAppointmentTypeCtrl } from './booking.appointment-type';
import { BookingRequestCtrl }         from './booking.request';
import { BookingRequestsCtrl }        from './booking.requests';
import { BookingsSettingsCtrl }       from './bookings.settings';
import { BookingsStates }             from './bookings.states.ajs';

angular.module('workshop.bookings', [])
  .config(BookingsStates)
  .controller('BookingAppointmentTypeCtrl', BookingAppointmentTypeCtrl)
  .controller('BookingRequestCtrl', BookingRequestCtrl)
  .controller('BookingRequestsCtrl', BookingRequestsCtrl)
  .controller('BookingsSettingsCtrl', BookingsSettingsCtrl);
